import { Component, Input, OnInit, inject } from '@angular/core';
import { Office } from 'app/core/models/office.model';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { PhoneNumberComponent } from '../phone-number/phone-number.component';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-office-fax',
    templateUrl: './office-fax.component.html',
    imports: [PhoneNumberComponent, FaIconComponent]
})
export class OfficeFaxComponent implements OnInit {
  private authService = inject(AuthenticationService);

  @Input() office: Office;
  @Input() allowLinkToOffice = true;

  canViewOffice = false;

  ngOnInit() {
    this.canViewOffice = this.authService.isCaptureAdminUser;
  }

  get linkTo(): string | null {
    return this.allowLinkToOffice && this.canViewOffice ? `/capture-admin/offices/${this.office.id}` : null;
  }
}
